import { Picture } from "@/components/wpl/image/src";

export interface ImageProps {
    source: string;
    altText?: string;
    width?: string;
    maxWidth?: string;
    height?: string;
    maxHeight?: string;
    objectFit?: "contain" | "cover" | "fill" | "none" | "scale-down";
    objectPosition?: string;
}

export const UniformImage = ({
    source,
    altText = "",
    width,
    maxWidth,
    height,
    maxHeight,
    objectFit,
    objectPosition
}: ImageProps) => {
    const imageStyle = {
        width,
        height,
        maxWidth,
        maxHeight,
        objectFit,
        objectPosition
    };

    return <Picture image={{ src: source, alt: altText }} style={imageStyle} />;
};
